import styled from "styled-components";

import Text from "@/components/Text";
import { HomeContainer } from "../index";
import { NavLink } from "react-router-dom";

const FooterText = styled(Text)`
  text-align: center;
  padding: 56px 0;
  display: flex;
  justify-content: space-between;
  a {
    text-decoration: underline;
    margin-left: 40px;
  }
`;

const HomeFooter = () => {
  return (
    <>
      <HomeContainer>
        <FooterText $type="smallMedium" $color="gray">
          © 2022 Backbone
          <span>
            <a
              href="https://surveys.hotjar.com/13dd9598-77c9-4013-90ec-ce073873adcd"
              target="_blank"
              rel="noreferrer noopener"
            >
              Share Feedback
            </a>
            <NavLink to="/privacy-policy">Privacy Policy</NavLink>
          </span>
        </FooterText>
      </HomeContainer>
    </>
  );
};

export default HomeFooter;
